export const FORMAT_TIME = 'hh:mm A';
export const TIME_VALUE_FORMAT = 'HH:mm';